// Defence-in-depth against duplicate rows in backend reference data.
// Some tenants have historical duplicate records (same tenant_id + name) — e.g.
// categories or dining options that were duplicated by a direct DB import that
// bypassed the API's duplicate-name check. POS / KDS surfaces must never render
// the same entity twice, so we collapse rows by name, keeping the most recent
// one (highest id) and preserving the original order of first appearance.
const dedupeByName = (rows) => {
    if (!Array.isArray(rows)) return [];
    const bestByName = new Map();
    rows.forEach(row => {
        if (!row || row.name == null) return;
        const existing = bestByName.get(row.name);
        if (!existing || (row.id ?? 0) > (existing.id ?? 0)) {
            bestByName.set(row.name, row);
        }
    });
    const seen = new Set();
    const result = [];
    rows.forEach(row => {
        if (!row || row.name == null || seen.has(row.name)) return;
        seen.add(row.name);
        result.push(bestByName.get(row.name));
    });
    return result;
};

export default dedupeByName;
